import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';

const CompleteProfilePage = () => {
  const { user, setUser } = useAuth(); // Get user for role check
  const [formData, setFormData] = useState({
    namaLengkap: '',
    affiliasi: '',
    noHp: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(''); // To show success message
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await api.get('/auth/profile');
        const userProfile = response.data.data.user;
        if (userProfile.namaLengkap) setFormData(prev => ({ ...prev, namaLengkap: userProfile.namaLengkap }));
        if (userProfile.affiliasi) setFormData(prev => ({ ...prev, affiliasi: userProfile.affiliasi }));
        if (userProfile.noHp) setFormData(prev => ({ ...prev, noHp: userProfile.noHp }));
        setLoading(false);
      } catch (err) {
        setError('Gagal mengambil data profil.');
        setLoading(false);
      }
    };
    fetchUserProfile();
  }, []);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!formData.namaLengkap.trim() || !formData.affiliasi.trim() || !formData.noHp.trim()) {
      setError('Nama Lengkap, Affiliasi, dan No HP harus diisi.');
      return;
    }

    try {
      const response = await api.put('/auth/profile', {
        namaLengkap: formData.namaLengkap.trim(),
        affiliasi: formData.affiliasi.trim(),
        noHp: formData.noHp.trim(),
      });
      
      // FINAL, SIMPLIFIED LOGIC:
      // We only need to check for a success status. The redirection will handle the rest.
      if (response.data && response.data.status === 'success') {
        setSuccess('Profile updated successfully. Redirecting...');
        
        // Update the user in context with the new data from the response
        if(response.data.data && response.data.data.user) {
          setUser(response.data.data.user);
        }

        // Use a timeout to allow the user to see the success message,
        // then perform a full page reload to ensure all guards have the fresh user data.
        setTimeout(() => {
          if (user && user.role === 'admin') {
            window.location.href = '/admin';
          } else {
            window.location.href = '/';
          }
        }, 1500); // 1.5-second delay

      } else {
        setError(response.data?.message || 'Gagal memperbarui profil: Respon tidak sesuai.');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Gagal memperbarui profil.');
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="min-h-screen flex items-center justify-center bg-teraplus-page-bg p-6">
      <form onSubmit={handleSubmit} className="bg-teraplus-card-bg p-8 rounded-xl shadow-lg ring-1 ring-black ring-opacity-5 max-w-md w-full">
        <h2 className="text-2xl font-bold mb-6 text-teraplus-text-default">Lengkapi Profil Anda</h2>
        {error && <p className="text-red-500 mb-4">{error}</p>}
        {success && <p className="text-green-500 mb-4">{success}</p>}
        <div className="mb-4">
          <label htmlFor="namaLengkap" className="block mb-1 text-teraplus-text-default font-medium">Nama Lengkap</label>
          <input
            id="namaLengkap"
            name="namaLengkap"
            type="text"
            value={formData.namaLengkap}
            onChange={handleChange}
            required
            className="w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-teraplus-brand-blue focus:border-teraplus-brand-blue"
            placeholder="Masukkan nama lengkap Anda"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="affiliasi" className="block mb-1 text-teraplus-text-default font-medium">Affiliasi (Nama Instansi/Perusahaan/Pribadi)</label>
          <input
            id="affiliasi"
            name="affiliasi"
            type="text"
            value={formData.affiliasi}
            onChange={handleChange}
            required
            className="w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-teraplus-brand-blue focus:border-teraplus-brand-blue"
            placeholder="Masukkan affiliasi Anda"
          />
        </div>
        <div className="mb-6">
          <label htmlFor="noHp" className="block mb-1 text-teraplus-text-default font-medium">No. HP (WhatsApp Aktif)</label>
          <input
            id="noHp"
            name="noHp"
            type="tel"
            value={formData.noHp}
            onChange={handleChange}
            required
            className="w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-teraplus-brand-blue focus:border-teraplus-brand-blue"
            placeholder="Contoh: 081234567890"
          />
        </div>
        <button
          type="submit"
          className="w-full py-2 px-4 bg-teraplus-accent text-teraplus-primary font-semibold rounded hover:bg-teraplus-accent-dark transition"
        >
          Simpan
        </button>
      </form>
    </div>
  );
};

export default CompleteProfilePage;
